/**
 * OrbDocCoreConceptsClosedCircuitENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsClosedCircuitENDocScreen
 */

import { useOrbDocCoreConceptsClosedCircuitENDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsClosedCircuitENDocScreenLogic';
import type { OrbDocCoreConceptsClosedCircuitENDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsClosedCircuitENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsClosedCircuitENDocView as OrbDocCoreConceptsClosedCircuitENDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsClosedCircuitENDocBodyView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitENDocBodyView';
import { OrbDocCoreConceptsClosedCircuitENDocFooterView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitENDocFooterView';
import { OrbDocCoreConceptsClosedCircuitENDocHeaderView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsClosedCircuitENDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsClosedCircuitENDocScreenConfig>;
}

export function OrbDocCoreConceptsClosedCircuitENDocScreenView({ config: propsConfig }: OrbDocCoreConceptsClosedCircuitENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsClosedCircuitENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsClosedCircuitENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsClosedCircuitEN" trait="OrbDocCoreConceptsClosedCircuitENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsClosedCircuitENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsClosedCircuitENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsClosedCircuitENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsClosedCircuitENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsClosedCircuitENDocScreenView;
